<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="name"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Name"
                                    name="name"
                                    id="name"
                                    v-model="name"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="professionId"
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid || !deletable"
                >
                    Delete Specialty
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '../../../../store/store';

export default {
    computed: {
        name: {
            get: function() {
                return store.state.professionEditor.name;
            },
            set: function(value) {
                this.setName(value);
            }
        },

        ...mapState('professionEditor', ['professionId', 'deletable'])
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions({
            getData: 'professionEditor/getData',
            saveData: 'professionEditor/saveData'
        }),

        ...mapMutations({
            setName: 'professionEditor/setName',
            toggleDeleteModal: 'professionEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        }
    }
};
</script>
